import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'bn-auth-layout',
  templateUrl: './auth-layout.component.html',
  imports: [RouterOutlet],
})
export class AuthLayoutComponent {}
